import { useState } from "react";
import { IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { styled } from "@mui/system";
import { useDocumentList } from "../../state/useDocumentList";
import { faCaretUp } from "@fortawesome/pro-solid-svg-icons";
import Grid from "@vapor/react-material/Grid";

const RotatingIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontFamily: "Font Awesome 6 Pro",
  fontSize: "16px",
  fontWeight: "900",
  lineHeight: "20px",
  textAlign: "left",
  transition: "transform 0.5s ease-in-out",
  "&.rotated": {
    transform: "rotate(180deg)",
  },
}));

const DataFilterTableHeader = ({ name }) => {
  const [arrowUp, setArrowUp] = useState(true);
  const { toggleFilterByDate, filterByNewestDate } = useDocumentList();

  const handleToggle = () => {
    setArrowUp(!arrowUp);
    toggleFilterByDate();
  };

  return (
    <Grid alignItems="center" display="flex" item sm={6}>
      <Typography color="primary.textTitleColor" variant="body500">
        {name}
      </Typography>
      <IconButton onClick={handleToggle}>
        <RotatingIcon className={arrowUp ? "" : "rotated"} icon={faCaretUp} />
      </IconButton>
    </Grid>
  );
};

export default DataFilterTableHeader;
